import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../css/Usuarios.css";
import Menu from "./components/Menu";
import { dB64 } from "../shared/Encriptacion";
import axios from "axios";
import { HEADERS_API } from "./NuevaGuia";
import { ValidarSesion } from "../shared/Validaciones";
import { ListaUnidadesMedida } from "../shared/UnidadesMedida";
import Paginador from "./components/Paginador";

export default function Productos(){
    // ======================================================================================================
    //#region HOOKS STATE
    // ======================================================================================================

    // ESTADOS DE CONTENIDO
    const[listaProductos, setListaProductos] = useState(<></>);

    // ESTADOS DE FILTRO
    const[filtroProducto, setFiltroProducto] = useState("");
    const[filtroUnidad, setFiltroUnidad] = useState("-");
    //#endregion

    // ESTADOS DE PAGINACIÓN
    const[paginador, setPaginador] = useState(<></>);

    // ======================================================================================================
    //#region HOOKS EFFECT
    // ======================================================================================================
    useEffect(()=>{
        ValidarSesion();
        ObtenerListaProductos(filtroProducto, filtroUnidad, 1);
    },[]);

    //#endregion

    // ======================================================================================================
    //#region HANDLERS
    // ======================================================================================================
    // ESTADOS DE CONTENIDO
    const HandlerListaProductos = (valor) => setListaProductos(valor);

    // ESTADOS DE FILTRO
    const HandlerFiltroProducto = (valor) => setFiltroProducto(valor.toUpperCase());
    const HandlerFiltroUnidad = (valor) => setFiltroUnidad(valor);
 
    // ESTADOS DE PAGINACIÓN
    const HandlerPaginador = (valor) => setPaginador(valor);

    //#endregion

    // ======================================================================================================
    //#region FUNCIONES
    // ======================================================================================================
    // FUNCIONES ASÍNCRONAS
    
    const ObtenerListaProductos = async(producto, unidad, pagina) => {
        const paramProducto = producto == "" ? "-" : producto;
        try{
            const response = await axios.get(URL_LISTAR_PRODUCTOS,{
                headers: HEADERS_API,
                params: {
                    fProducto: paramProducto,
                    fUnidad: unidad,
                    pagina: pagina
                }
            }).catch(error => {
                throw new Error(error.message);
            });
            HandlerListaProductos(response.data.lista);
            if(response.data.lista.length > 0){
                const total = response.data.lista[0].total;
                const regPag = response.data.lista[0].regPag;
                const pag = response.data.lista[0].pagina;
                HandlerPaginador(<Paginador totalRegistros={total} regPag={regPag} pagina={pag} funcion={FuncionPaginador}/>);
            }else{
                HandlerPaginador(<></>);
            }
        }catch(error){
            console.log(error);
        }
    }

    // FUNCIONES COMPLEMENTARIAS
    const QuitarFiltros = () => {
        HandlerFiltroProducto("");
        HandlerFiltroUnidad("-")
        ObtenerListaProductos("","-",1);
    }

    // FUNCIÓN PAGINADOR
    const FuncionPaginador = (pagina) =>{
        ObtenerListaProductos(filtroProducto, filtroUnidad, pagina);
    }
    //#endregion

    // ======================================================================================================
    //#region CONTENIDO
    // ======================================================================================================
    return(<>
    <Menu/>
    <div className="container">
        <div className="row">
            <div className="col-12 py-2 border-bottom border-secondary text-secondary text-center text-md-start">
                <h2>{dB64(localStorage.getItem('r6'))}</h2>
            </div>
            <div className="col-12 py-3 text-center">
                <h2>PRODUCTOS</h2>
            </div>
            <div className="col-12 py-1">
                <Link to={"/nuevo-producto"}>
                    <button className="btn btn-primary">Nuevo Producto</button>
                </Link>
            </div>
            {/* FILTROS */}
            <div className="col-12 col-md-5 p-1">
                <div className="form-floating">
                    <input onChange={e=>HandlerFiltroProducto(e.target.value)} value={filtroProducto} maxLength={50} type="text" className="form-control" placeholder="Buscar" id="filtro-producto" autoComplete="off"/>
                    <label htmlFor="filtro-producto">Buscar</label>
                </div>
            </div>
            <div className="col-12 col-md-5 p-1">
                <div className="form-floating">
                    <select onChange={e=>HandlerFiltroUnidad(e.target.value)} value={filtroUnidad} id="und-producto" 
                    className="form-select" placeholder="Unidad de medida">
                        <option value="-">Seleccionar</option>
                        <ListaUnidadesMedida/>
                    </select>
                    <label htmlFor="und-producto">Unidad de medida</label>
                </div>
            </div>
            <div className="col-12 col-md-2">
                <button onClick={e=>ObtenerListaProductos(filtroProducto, filtroUnidad, 1)} className="btn btn-primary my-1 w-100">Filtrar</button>
                <button onClick={QuitarFiltros} className="btn btn-secondary w-100">Quitar filtros</button>
            </div>
            {/* TABLA */}
            <div className="contenedor-tabla py-4">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Descripción</th>
                            <th>Unidad</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaProductos.length > 0 ? listaProductos.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.codigo}</td>
                                    <td>{item.descripcion}</td>
                                    <td>{item.unidad}</td>
                                    <td>
                                        <Link to={`/detalle-producto/${item.codigo}`} className="btn btn-primary">
                                        Detalles
                                        </Link>
                                    </td>
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={5} className="text-secondary text-center fs-4 fw-semibold">Sin resultados</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center">
                {paginador}
            </div>
        </div>
    </div>
    </>)

    //#endregion
}

// ======================================================================================================
//#region CONSTANTES
// ======================================================================================================
const URL_LISTAR_PRODUCTOS = process.env.REACT_APP_URL_LISTAR_PRODUCTOS
//#endregion